export default __webpack_public_path__ + "static/media/dollarIcon.e1fd862a.svg";